import React from "react";
import Section from "../components/Section";

function ContactUs() {
  return (
    <Section id="contact" icon="✉️" title="Contact Us">
      <p>
        If you have any questions, concerns, or requests regarding this Privacy Policy or how your
        data is handled, please contact us:
      </p>
      <div className="contact-box">
        <p><strong>Food-Is — Privacy Enquiries</strong></p>
        <p>Email: <a href="mailto:techinvento@icloud.com">techinvento@icloud.com</a></p>
        <p style={{ marginTop: "8px", fontSize: "0.88rem", color: "#888" }}>
          We aim to respond to all privacy-related enquiries within 30 days.
        </p>
      </div>
    </Section>
  );
}

export default ContactUs;
